// @flow
import { connect } from 'react-redux';
import React, { useEffect } from 'react';

import HomeTopBannerTCVM from 'src/components/HomePage/HomeTopBannerTCVM';
import SectionPayLater from 'src/components/Merchant/Campaign/GeneralCashback202505/SectionPayLater';
import SectionMerchants from 'src/components/Merchant/Campaign/GeneralCashback202505/SectionMerchants';
import SectionHowTo from 'src/components/HomePage/SectionHowTo/SectionHowTo';
import { StickyNav } from 'src/components';

import SectionPayment from 'src/components/HomePage/SectionPayment/SectionPayment';
import SectionSecurity from 'src/components/HomePage/SectionSecurity/SectionSecurity';
import { HOME_FAQS, SITE_METADATA } from '../constants';
import { fetchEditorsPicks } from '../redux/editors-pick';
import Layout from '../components/Layout/Layout';
import TopMerchantBanners from '../components/HomePage/TopMerchantBanners';
import { fetchCampaigns } from '../redux/campaign';
import FAQLinks from '../components/FAQ/FAQLinks';
import AppUpSell from '../components/HomePage/AppUpSell';

const NAVS = [
  'トップ',
  'ペイディとは',
  '使えるお店',
  '使い方',
  'よくあるご質問',
];

const APPLINK = 'https://paidy.onelink.me/GTiS/WebsiteTPND';

const IndexPage = ({ _fetchEditorsPicks, _fetchCampaigns, editorsPicks }) => {
  useEffect(() => {
    _fetchEditorsPicks();
    _fetchCampaigns();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      isCompanyPage
      SEOProps={{
        title: SITE_METADATA.top.title,
        description: SITE_METADATA.top.description,
      }}
      isSticky={false}
    >
      {/* main banner  */}
      <HomeTopBannerTCVM showAppDownload={false} />

      {/* sticky nav */}
      <StickyNav navs={NAVS} />

      <AppUpSell />

      <TopMerchantBanners id={NAVS[0]} />
      <SectionPayLater downloadLink={APPLINK} id={NAVS[1]} />
      <SectionMerchants id={NAVS[2]} editorItems={editorsPicks} />
      <SectionHowTo id={NAVS[3]} />

      <SectionPayment />
      <SectionSecurity />
      <FAQLinks id={NAVS[4]} questions={HOME_FAQS} />
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  editorsPicks: state.editorsPick.data,
  campaigns: state.campaign.data,
});

const mapDispatchToProps = (dispatch) => ({
  _fetchEditorsPicks: () => dispatch(fetchEditorsPicks()),
  _fetchCampaigns: () => dispatch(fetchCampaigns()),
});

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);
